import { BrandingOverrideProvider } from '@/hooks/use-branding'

import NavBar from '@/components/layouts/nav/navbar'

import { getNonFsdsHeaderBrandingOverride } from '@/configs/non-fsds-config'

import { HeaderConfig } from '@/types/header-footer-config'

interface PuckHeaderSectionProps {
  visible?: boolean
  fallbackLogoUrl?: string
  brandHref?: string
  brandName?: string
  headerConfig?: HeaderConfig
}

export default function PuckHeaderSection({
  visible = true,
  fallbackLogoUrl = '',
  brandHref = '/',
  brandName = '',
  headerConfig,
}: PuckHeaderSectionProps) {
  if (!visible) return null

  return (
    <BrandingOverrideProvider
      value={getNonFsdsHeaderBrandingOverride({ brandHref, fallbackLogoUrl, brandName })}
    >
      <section className="puck-header-section overflow-hidden rounded-lg border border-dashed border-border bg-background">
        <div className="relative min-h-16 [&_header]:!sticky [&_header]:!top-0 [&_header]:!left-auto [&_header]:!right-auto">
          <NavBar headerConfig={headerConfig} />
        </div>
      </section>
    </BrandingOverrideProvider>
  )
}
